import { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import { defaultPagination } from "src/constant";
import { useGetOverviewBirthday } from "src/pages/Overview/api/queries";
import { RoutePaths } from "src/pages/routePaths";

const useBirthdayDropdownMenuHandler = () => {
  const navigate = useNavigate();

  const { data, isLoading } = useGetOverviewBirthday({
    ...defaultPagination,
  });

  const handleViewDetail = () =>
    startTransition(() => navigate(RoutePaths.Birthday));

  return {
    summary: data?.summary,
    isLoading,
    handleViewDetail,
  };
};

export default useBirthdayDropdownMenuHandler;
